export const extractMediaUrlsOnly = (segments) => {
  const mediaUrls = [];

  segments.forEach(segment => {
    const { items } = segment;
    
    // Extract image URLs
    if (items.images && items.images.length > 0) {
      items.images.forEach(image => {
        if (image.src) {
          mediaUrls.push(image.src);
        }
      });
    }

    // Extract video URLs
    if (items.videos && items.videos.length > 0) {
      items.videos.forEach(video => {
        if (video.src) {
          mediaUrls.push(video.src);
        }
      });
    }

    // Extract audio URLs
    if (items.audios && items.audios.length > 0) {
      items.audios.forEach(audio => {
        if (audio.src) {
          mediaUrls.push(audio.src);
        }
      });
    }

    // Extract document URLs
    if (items.documents && items.documents.length > 0) {
      items.documents.forEach(document => {
        if (document.src) {
          mediaUrls.push(document.src);
        }
      });
    }
  });

  return mediaUrls;
}; 